

import { Component, Vue } from "vue-property-decorator"
import { Getter, Mutation } from "vuex-class"

import api from "@/services/api"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import { BModal } from "bootstrap-vue"
import { UserSettings } from "@/types/userSettings"
import DataForm from "./Config/DataForm.vue"

@Component({
	components: {
		"userSettingsModal": BModal,
		"scrollbar": VuePerfectScrollbar,
		"data-form": DataForm
	}
})
export default class UserSettingsModal extends Vue {
	@Getter("getUserSettings")
	public userSettings!: UserSettings;

	@Getter("getCaseName") getCaseName!: string;
	@Getter("getRecordName") getRecordName!: string;

	@Mutation public setUserSettings!: (userSettings: UserSettings) => void;

	private isOpen: boolean = false;

	public get viewsOpeningOptions (): any[] {
		if (!this.userSettings) {
			return []
		}

		return [
			{
				id: "sameTab",
				title: "Same tab"
			},
			{
				id: "newTab",
				title: "New tab"
			}
		]
	}

	public get columns (): any[] {
		if (!this.userSettings) {
			return []
		}

		return [
			{
				key: "settings.viewFoldersExpanded",
				label: "Automatically expand folders in Views",
				dataType: "checkbox",
				valueColumn: "settings.viewFoldersExpanded"
			},
			{
				key: "settings.scheduleFoldersExpanded",
				label: "Automatically expand folders in Schedules",
				dataType: "checkbox",
				valueColumn: "settings.scheduleFoldersExpanded"
			},
			{
				key: "settings.viewsOpening",
				label: "Opening from Insights",
				dataType: "list",
				valueColumn: "settings.viewsOpening",
				options: this.viewsOpeningOptions,
				placeholder: "New Tab",
				tooltip: `Affects how ${this.getRecordName}s/${this.getCaseName}s in views and insights will be opened when clicked on. The opposite setting will happen when ctrl + clicking instead.`
			}
		]
	}

	public open () {
		this.isOpen = true
	}

	private async updateUser () {
		await api.userSettingsSave(this.userSettings)
	}
}
